import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static classes = ['collapsedTeasers'];

  connect() {
    if (
      this.element.querySelectorAll(
        '[data-article-teaser-component-is-alternative-format]'
      ).length > 0
    ) {
      this.element.classList.add(this.collapsedTeasersClass);
    }
  }
}
